import { createGlobalStyle } from 'styled-components';
import { devices } from './device';
const GlobalStyle = createGlobalStyle`
:root {
  --font-family: 'Lato';
  --box-shadow: 0px 2px 26px rgba(0, 0, 0, 0.0741095);
  --bg-color: #FFFFFF;
  --bs-primary: #FFBF00 !important;
  --bs-primary-yellow: #FFEFBF !important;
  --bs-body-font-size: 20px !important;
  --bs-body-line-height: 28px;
  --light-yellow: #FFF3DC;
  --bs-link-color: #04AAFF !important;
  --bs-grey: #DCDCDE;
  --bs-etiqa-teal: #49C0B6;
  --bs-etiqa-grey: #707070;
  --bs-etiqa-pale-yellow: #FFF3CE;
  --bs-etiqa-home-orange: #F7941E;
  --bs-etiqa-home-green: #10B981;
  --bs-etiqa-home-grey: #767676; 
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 8px;
  no-repeat;
  border-radius: 8px;
  outline: 1px solid #707070;
}

input[type="range"]::-webkit-slider-runnable-track::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, white 0%, white 100%); /* Apply the gradient as background */
  outline: 1px solid #707070; /* Add a solid 1px outline */
}

input[type="range"]::-moz-range-track {
  background: linear-gradient(to right, #to right 0%, #to right 50%, #FFFFFF) no-repeat;
}

input[type="range"]::-ms-fill-lower {
  background: linear-gradient(to right, #to right 0%, #to right 50%, #FFFFFF) no-repeat;
}

input[type="range"]::-ms-fill-upper {
  background: #FFFFFF;
}

input[type="range"]::-webkit-slider-thumb {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #B8BABC;
  margin-top: -6px;
}

.dropdown-menu {
  --bs-dropdown-link-active-bg: #FFBF00 !important;
}

.btn-primary {
  --bs-btn-bg: #FFBF00 !important;
  --bs-btn-border-color: #FFBF00 !important;
  --bs-btn-hover-bg: #FFF3DC !important;
  --bs-btn-hover-border-color: #FFF3DC !important;
  --bs-btn-disabled-bg: #FFF3DC !important;
  --bs-btn-active-border-color: #FFF3DC !important;
  --bs-btn-disabled-border-color: #FFBF00 !important;
}

.btn-link {
  padding: 0;
  color: black;
}

span, a {
  text-decoration: none;
  font-weight: 500;
}

* {
  box-sizing: border-box;
  font-family: var(--font-family);
}

.box-container{
  border: none;
  box-shadow: var(--box-shadow);
  background-color: var(--bg-color);
  border-radius: 4px;
}

.container ul {
  padding-left: 1em
}

ol > li {
  list-style: inherit;
}

small {
  color: #354F53;
  font-size: 10px;
}

.form-check-input:checked {
  background-color: var(--bs-etiqa-home-green) !important;
  border-color: var(--bs-etiqa-home-green) !important;
}

.input-bg-success .form-check-input:checked {
  background-color: rgb(var(--bs-success-rgb)) !important;
  border-color: rgb(var(--bs-success-rgb)) !important;
}

.form-check-input:focus {
  box-shadow: unset !important;
}

.card-title {
  font-size: 20px;
  font-weight: 700 !important;
}

.card-text {
  font-size: 16px !important;
}

.btn-xs {
  padding: .25rem .5rem !important;
  font-size: 10px !important
}

.custom-radio +.btn {
  border: 1px solid #B1B1B1 !important;
  border-radius: 8px;
}

.custom-radio :checked+.btn {
  background: var(--bs-primary) !important;
  color: #333 !important;
  border: 1px solid var(--bs-primary) !important;
  border-radius: 8px;
  font-weight: 700;
}

.btn-check+.btn {
  border: 1px solid #B1B1B1 !important;
  border-radius: 8px;
}

.btn-check:checked+.btn {
  background: var(--bs-primary-yellow) ;
  color: #333 ;
  border: 1px solid var(--bs-primary) ;
  border-radius: 8px;
  font-weight: 700;
}

.accordion {
  --bs-accordion-btn-color: inherit !important;
  --bs-accordion-btn-bg: inherit !important;
  --bs-accordion-active-color: inherit !important;
  --bs-accordion-active-bg: inherit !important;
}

.shadow-none .accordion-button {
  box-shadow: none !important;
}

.accordion-button::after {
  background-image: var(--bs-accordion-btn-icon) !important;
}

.text-white .accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23f8f9fa'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}

.bg-etiqa-primary {
  background-color: var(--bs-primary) !important;
}

.border-etiqa-primary.border,
.border-etiqa-primary.border-top,
.border-etiqa-primary.border-bottom,
.border-etiqa-primary.border-start,
.border-etiqa-primary.border-end {
  border-color: var(--bs-primary) !important;
}

// Custom styles.
.bg-lightyellow {
  background-color: var(--light-yellow) !important;
}

.bg-yellow {
  background-color: #FFFFEA;
}

.pre-line {
  white-space: pre-line;
}

.link {
  font-size: 16px;
  font-weight: 700 !important;
  line-height: 18px;
  color: var(--bs-link-color) !important;
  cursor: pointer;

  &:hover {
    color: var(--bs-link-hover-color) !important;
  }
}

.text-underline {
  text-decoration: underline;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.rdp {
  --rdp-accent-color: #FFBF00 !important;
}

.color-bs-primary {
  color: var(--bs-primary);
}

.color-bs-teal {
  color: var(--bs-etiqa-teal);
}

.color-bs-grey {
  color: var(--bs-etiqa-grey);
}

.color-green {
  color: #059669;
}

.bg-bs-teal {
  background-color: var(--bs-etiqa-teal);
}

.bg-bs-pale-yellow {
  background-color: var(--bs-etiqa-pale-yellow);
}

.weight-400 {
  font-weight: 400;
}

.text-12px {
  font-size: 12px !important;
}

.text-16px {
  font-size: 16px !important;
}

.text-14px {
  font-size: 14px !important;
}

.text-18px {
  font-size: 18px !important;
}

.text-20px {
  font-size: 20px !important;
}

.text-24px {
  font-size: 24px !important;
}

.text-28px {
  font-size: 28px !important;
}

.text-30px {
  font-size: 30px !important;
}

.text-32px {
  @media only screen and ${devices.xs} {
    font-size: 22px !important;
  }

  @media only screen and ${devices.md} {
    font-size: 32px !important;
  }
}

@media screen and ${devices.xs} {
  :root{
    font-size: 14px;
  }

  .container {
    --bs-gutter-x: 2.5rem;
  }
}

@media screen and ${devices.lg} {
  :root{
    font-size: 16px;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.text-dark{
  font-weight: bolder;
  margin-top: 0.4rem;
  font-size: 14px;
  transition: color 2s ease-in-out;
}

.btn-filled-primary {
  width: 100%;
  padding: 16px 24px 16px 24px;
  gap: 10px;
  background-color: var(--bs-primary);
  border: 0 !important;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold !important;
  color: black !important;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    background-color: var(--bs-primary) !important;
    opacity: 0.8;
  }
}

.btn-outline-dark {
  padding: 16px 24px 16px 24px;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid;
  font-weight: bold !important;
  font-size: 16px;
  line-height: 20px;
  min-height: 48px;
  min-width: 84px;
}

.back-btn {
  border-radius: 4px;
}

.accordion-button {
  font-weight: 600;
  padding: 1rem 0.25rem;
  line-height: 22px;

  @media only screen and ${devices.xs} {
    font-size: 16px;
  }

  @media only screen and ${devices.md} {
    font-size: 18px;
  }
}

.accordion-body {
  text-align: left;
  line-height: 22px;

  @media only screen and ${devices.xs} {
    font-size: 16px;
    padding: 1rem 1.25rem 1rem 0.25rem;
  }

  @media only screen and ${devices.md} {
    font-size: 18px;
    padding: 1rem 2rem 0 0 ; 
  }
}

.primary-line {
  color: var(--bs-primary);
  opacity: 1;
  border-width: 2px !important;
}

.form-title-icon {
  font-size: 30px !important;
  font-weight: 700;
  vertical-align: middle;
  margin-left: 1.5rem;
}

.modal {
  --bs-modal-width: 595px;
}

.nav-primary {
  font-weight: 700;
  font-size: 16px;
  --bs-link-color: #333333;
  margin: 0.75rem 0 !important;

  .nav-link:hover {
    opacity: 0.8;
    color: black;
  }

  .nav-link {
    opacity: 0.5;
    border: none;
    border-bottom: 2px solid transparent; /* Set initial border to transparent */
  }

  .nav-link.active {
    opacity: 1;
    border-color: var(--bs-primary);
  }
}

.discount-text {
  text-decoration: line-through;
  color: #B1B1B1;
  margin-right: 0.5rem;
}

.text-danger {
  color: var(--bs-danger);
  margin-bottom: 0;

  @media only screen and ${devices.xs} {
    font-size: 14px;
  }

  @media only screen and ${devices.md} {
    font-size: 16px;
  }
}

.fixed-bottom-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  padding: 1rem 0 1.25rem 0;
  z-index: 1000;
}

.divider {
  display: flex;
  align-items: center;
}

.divider::before, .divider::after {
  flex: 1;
  content: '';
  padding: 0.5px;
  opacity: 0.5;
  background-color: black;
  margin: 1.5rem;
}

.container-padding-hide {
  @media only screen and ${devices.xs} {
    padding-bottom: 8rem;

  }

  @media only screen and ${devices.md} {
    padding-bottom: 9rem;
  }
}

.container-padding-show {
  @media only screen and ${devices.xs} {
    padding-bottom: 38rem;

  }

  @media only screen and ${devices.md} {
    padding-bottom: 24rem;
  }
}
`;

export default GlobalStyle;
